import axios from './Connection';

import unique from 'array-unique';
import {LOGIN_STATES} from "../Store/actionTypes";
import t from 'typy';

let accessTokens = [];

function addAccessTokenToCheck(token) {
    accessTokens.push(token);
    unique(accessTokens);
}

function clearAccessToken() {
    accessTokens = []
}


async function verifyCredentials(updateState, updateUserData) {
    try {
        let r = await axios.get('/api/auth/hasAccess/access');

        let state = LOGIN_STATES.NOT_LOGGED_IN;

        let access = [];
        if (t(r, 'status').safeNumber === 200 && t(r, 'data.access').safeBoolean) {
            state = LOGIN_STATES.LOGGED_IN;
            Promise.all(accessTokens.map(e =>
                new Promise(async (resolve, _) => {
                    let response = await axios.get('/api/auth/hasAccess/' + e);
                    if (t(response, 'status').safeNumber === 200) {
                        resolve([e, t(response, 'data.access').safeBoolean]);
                    }
                }).then(v => {
                    if (v[1] === true)
                        access.push(v[0]);
                    updateUserData(access);
                }))
            ).then(() => {
                updateState(state);
            });
        } else {
            updateState(state);
        }

    } catch (error) {
        let state = LOGIN_STATES.NOT_LOGGED_IN
        if (error?.message?.includes?.("Network Error")) {
            state = LOGIN_STATES.CONNECTION_ERROR;
        }

        updateState(state)
    }
}

export {verifyCredentials, addAccessTokenToCheck, accessTokens, clearAccessToken};